(function () {
  "use strict";

  const MOBILE_BREAKPOINT = 768;
  const BOTTOM_OFFSET_MOBILE = "130px";
  const BOTTOM_OFFSET_DESKTOP = "90px";

  function applyOffset() {
    const cmp = document.querySelector("pandectes-cmp");
    if (!cmp || !cmp.shadowRoot) return;
    const btn = cmp.shadowRoot.querySelector("button.widget");
    if (!btn) return;

    const offset = window.innerWidth <= MOBILE_BREAKPOINT
      ? BOTTOM_OFFSET_MOBILE
      : BOTTOM_OFFSET_DESKTOP;
    btn.style.setProperty("bottom", offset, "important");
  }

  // Initial run (when Pandectes is already loaded)
  applyOffset();

  // Resize listener — debounced
  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(applyOffset, 150);
  });

  // MutationObserver für async-geladenes Pandectes (App-Embed lädt nach DOM-Ready)
  const docObserver = new MutationObserver(() => {
    const cmp = document.querySelector("pandectes-cmp");
    if (!cmp || !cmp.shadowRoot) return;
    applyOffset();
    // Shadow auch beobachten — Widget kann später erscheinen (nach Banner-Click)
    if (!cmp.shadowRoot.__dzObserved) {
      cmp.shadowRoot.__dzObserved = true;
      new MutationObserver(applyOffset).observe(cmp.shadowRoot, {
        childList: true,
        subtree: true,
      });
    }
  });
  docObserver.observe(document.body, { childList: true, subtree: true });
})();
